import {
  GET_QUESTIONS,
  QUESTIONS,
  AREAS,
  GET_AREAS
} from 'redux/actions';

export const questions = ({ questions }) => {
  return {
    type: QUESTIONS,
    payload: { questions },
  };
};

export const getQuestions = (filter) => {
  return {
    type: GET_QUESTIONS,
    payload: { filter },
  };
};

export const areas = ({ areas }) => {
  return {
    type: AREAS,
    payload: { areas },
  };
};

export const getAreas = (filter) => {
  return {
    type: GET_AREAS,
    payload: { filter },
  };
};